module.exports = __webpack_public_path__ + "static/media/logo_hyponav_beta.7b906068.svg";